import Swiper from 'swiper/swiper-bundle.min.mjs'
const swiper = new Swiper('.immoSwiper', {
  loop: true,
  spaceBetween: 0,
  slidesPerView: 1,
  pagination: {
    el: '.immoSwiper .swiper-pagination',
    type: 'progressbar'
  },
  // Navigation arrows
  navigation: {
    nextEl: '.immoSwiper .swiper-button-next',
    prevEl: '.immoSwiper .swiper-button-prev'
  }
});